import { cn } from '@/lib/utils';

/**
 * Deterministic-color initials avatar used by the redesigned active Loan Center
 * (borrower cell, officer cell, pipeline cards, drawer). Feature-local — promote
 * to `src/components/ui/` only when a second consumer appears.
 */
interface InitialsAvatarProps {
  name?: string | null;
  size?: number;
  className?: string;
  title?: string;
}

function hashHue(str: string): number {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h * 31 + str.charCodeAt(i)) >>> 0;
  }
  return h % 360;
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) {
return '?';
}
  if (parts.length === 1) {
return parts[0].slice(0, 2).toUpperCase();
}
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

export function InitialsAvatar({ name, size = 24, className, title }: InitialsAvatarProps) {
  const resolvedName = name?.trim() || '';
  const hue = resolvedName ? hashHue(resolvedName) : 215;
  const bg = `hsl(${hue} 60% 88%)`;
  // 28% lightness keeps the initials at 4.5:1 or better against the 88% tint for every hue.
  const fg = `hsl(${hue} 40% 28%)`;
  const fontSize = Math.max(9, Math.round(size * 0.4));

  return (
    <span
      aria-hidden={!title}
      title={title ?? resolvedName}
      className={cn(
        'inline-flex items-center justify-center rounded-full font-medium select-none flex-shrink-0',
        className
      )}
      style={{
        width: size,
        height: size,
        backgroundColor: bg,
        color: fg,
        fontSize,
        lineHeight: 1
      }}
    >
      {resolvedName ? initials(resolvedName) : '?'}
    </span>
  );
}
